import React from "react";
import BroadcastTrigger from "./broadcast";
import EditMessages from "./EditMessages";
import useToggle from "../../../../../hooks/useToggle";
import TriggerModel from "../triggers/TriggerModel";
import {
  useAspDispatch,
  useAspSelector,
} from "../../../../../test/jest-redux-hooks";
import { useParams } from "react-router-dom";
import { updateToggleToast } from "../../../../../reduxToolkit/appSlice";
import QrCodeTrigger from "./qrCode";
import AdsTrigger from "./ads/Index";
import ApiWebhookConfig from "./apiTrigger/ApiWebhookConfig";
import KeywordTrigger from "./keywordTrigger";

// constants
import { ACTIONS_LIST, OPERATIONS_LIST } from "../../../constants/triggers";

const NodeEditMode = ({
  originalData,
  node,
  onChange,
  onTriggerClick,
  findEmptySpace,
  allowToAddNode,
  toggleNodeEditMode,
  toggleLastNode,
  allowToEditFlow,
  removeEdges,
  updateEdgesCoordinates,
  handleCancelEditMode,
  getUnSavedEdge,
  sequenceDetails,
  findPreviousNode
}) => {
  const [openTriggerModel, setOpenTriggerModel] = useToggle(false);
  const actionTypes = ACTIONS_LIST.map(item => item?.key);

  return (
    <>
      {[...(ACTIONS_LIST || []), ...(OPERATIONS_LIST || [])].map(item => item?.key).includes(node?.type) && (
        <EditMessages
          originalData={originalData}
          node={node}
          onTriggerClick={onTriggerClick}
          onChange={onChange}
          findEmptySpace={findEmptySpace}
          toggleNodeEditMode={toggleNodeEditMode}
          toggleLastNode={toggleLastNode}
          allowToEditFlow={allowToEditFlow}
          removeEdges={removeEdges}
          updateEdgesCoordinates={updateEdgesCoordinates}
          handleCancelEditMode={handleCancelEditMode}
          getUnSavedEdge={getUnSavedEdge}
          findPreviousNode={findPreviousNode}
          />
      )}
      {node?.type === "TRIGGER" ? (
        node?.trigger_type === "CAMP_WAPP_BCAST" ? (
          <BroadcastTrigger
            node={node}
            originalData={originalData}
            onChange={onChange}
            toggleNodeEditMode={toggleNodeEditMode}
            allowToEditFlow={allowToEditFlow}
            removeEdges={removeEdges}
            sequenceDetails={sequenceDetails}
          />
        ) : node?.trigger_type === "CAMP_QR_URL" ? (
          <QrCodeTrigger
            node={node}
            originalData={originalData}
            onChange={onChange}
            toggleNodeEditMode={toggleNodeEditMode}
            allowToEditFlow={allowToEditFlow}
            removeEdges={removeEdges}
            sequenceDetails={sequenceDetails}
          />
        ) : node?.trigger_type === "API_TRIGGER" ? (
          <ApiWebhookConfig
            node={node}
            originalData={originalData}
            onChange={onChange}
            toggleNodeEditMode={toggleNodeEditMode}
            allowToEditFlow={allowToEditFlow}
            removeEdges={removeEdges}
            sequenceDetails={sequenceDetails}
          />
        ) : node?.trigger_type === "Meta Ads" ? (
          <>
            <AdsTrigger
              node={node}
              originalData={originalData}
              onChange={onChange}
              toggleNodeEditMode={toggleNodeEditMode}
              allowToEditFlow={allowToEditFlow}
              removeEdges={removeEdges}
              sequenceDetails={sequenceDetails}
            />
          </>
        ) : node?.trigger_type === "KEYWORD_TRIGGER" ? (
          <KeywordTrigger
            node={node}
            originalData={originalData}
            onChange={onChange}
            toggleNodeEditMode={toggleNodeEditMode}
            allowToEditFlow={allowToEditFlow}
            removeEdges={removeEdges}
            sequenceDetails={sequenceDetails}
          />
        ) : (
          <></>
        )
      ) : (
        <></>
      )}
      {node?.type === "NEW" && (
        <TriggerModel
          type={"tab"}
          open={openTriggerModel}
          setOpen={setOpenTriggerModel}
          onTriggerClick={(data) => {
            if (allowToEditFlow) onTriggerClick({ data, node });
          }}
          allow={allowToEditFlow && allowToAddNode()?.allow}
        />
      )}
    </>
  );
};

export default NodeEditMode;
